const PARTY_ROUTE_REGEX =
  /^\/parties\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?:\/|$)/i;

export function getActivePartyIdFromPathname(
  pathname: string | null,
): string | null {
  if (!pathname) {
    return null;
  }

  return pathname.match(PARTY_ROUTE_REGEX)?.[1] ?? null;
}
